import {
	DropdownMenuRadioGroup,
	DropdownMenuRadioItem,
	DropdownMenuSub,
	DropdownMenuSubContent,
	DropdownMenuSubTrigger,
} from "@/components/ui/dropdown-menu";
import { useTheme } from "@/components/useTheme";
import { m } from "@/paraglide/messages";

export function ModeToggle({ children }: { children: React.ReactNode }) {
	const { theme, setTheme } = useTheme();

	return (
		<DropdownMenuSub>
			<DropdownMenuSubTrigger>{children}</DropdownMenuSubTrigger>
			<DropdownMenuSubContent>
				<DropdownMenuRadioGroup
					value={theme}
					onValueChange={(value) =>
						setTheme(value as "light" | "dark" | "system")
					}
				>
					<DropdownMenuRadioItem value="light">
						{m.cozy_long_cuckoo_ascend()}
					</DropdownMenuRadioItem>
					<DropdownMenuRadioItem value="dark">
						{m.north_helpful_wolf_embrace()}
					</DropdownMenuRadioItem>
					<DropdownMenuRadioItem value="system">
						{m.loose_candid_pony_ascend()}
					</DropdownMenuRadioItem>
				</DropdownMenuRadioGroup>
			</DropdownMenuSubContent>
		</DropdownMenuSub>
	);
}
